var icon = require('vue-svgicon')
icon.register({
  'sign-out': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<defs/><path pid="0" class="cls-2" d="M22 12L18 8V11H8V13H18V16L22 12ZM16 5C15.9961 4.47078 15.7841 3.96435 15.4099 3.59012C15.0357 3.2159 14.5292 3.00393 14 3H5C4.47078 3.00393 3.96435 3.2159 3.59012 3.59012C3.2159 3.96435 3.00393 4.47078 3 5V19C3.00393 19.5292 3.2159 20.0357 3.59012 20.4099C3.96435 20.7841 4.47078 20.9961 5 21H14C14.5292 20.9961 15.0357 20.7841 15.4099 20.4099C15.7841 20.0357 15.9961 19.5292 16 19V17H14V19H5V5H14V7H16V5Z"/>'
  }
})
